import { apiClient } from './apiClient';

export interface CategoryTranslation {
  languageCode: string;
  name: string;
  description?: string;
}

export interface Category {
  id: string;
  slug: string;
  isActive: boolean;
  translations: CategoryTranslation[];
  createdAt: string;
  updatedAt: string;
}

export const categoryService = {
  async getAll(includeInactive = false): Promise<Category[]> {
    const endpoint = `/category${includeInactive ? '?includeInactive=true' : ''}`;
    return apiClient.get<Category[]>(endpoint);
  },

  async getBySlug(slug: string): Promise<Category> {
    return apiClient.get<Category>(`/category/slug/${slug}`);
  },

  async getById(id: string): Promise<Category> {
    return apiClient.get<Category>(`/category/${id}`);
  },
};

/**
 * Get the localized name for a category
 * @param category The category object
 * @param lang The language code (default: 'pl')
 * @returns The localized name or slug as fallback
 */
export function getCategoryName(category: Category, lang = 'pl'): string {
  const translation =
    category.translations.find((t) => t.languageCode === lang) ||
    category.translations.find((t) => t.languageCode === 'en') ||
    category.translations[0];
  return translation?.name || category.slug;
}

/**
 * Get the slug from a category (for API calls)
 */
export function getCategorySlug(category: Category): string {
  return category.slug;
}
